import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { statusPage } from "../../../Constant";
import PolicyCancelledPage from "../PolicyCancelledPage";
import PolicyFailedPage from "../PolicyFailedPage";
import PolicyIssuedPage from "../PolicyIssuedPage";
import PolicyPendingPage from "../PolicyPendingPage";

const StatusPage = () => {
  const status = useSelector((state) => state.trackPolicyDetails?.policyStatus);
  const navigate = useNavigate();
  const nxtScreen = () => {
    switch (status) {
      case statusPage.expired:
      case statusPage.lapsed:
      case statusPage.Terminated:
      case statusPage.cancelled:
        return <PolicyCancelledPage />;
      case statusPage.Rejected:
        return <PolicyFailedPage />;
      case statusPage.enforced:
        return <PolicyIssuedPage />;
      case statusPage.pending:
      case statusPage.PendingRenewal:
      case statusPage.RENEWALPENDING:
        return <PolicyPendingPage />;
      default:
        return navigate(-1);
    }
  };
  return <>{nxtScreen()}</>;
};

export default StatusPage;
